import { useEffect, useState, type JSX } from 'react';
import type { EffectProps } from './types';
import { markEffectActivated, isEffectActivated } from './effectRegistry';

export function GlitchBubble({ params, trigger, triggerDelayMs, onComplete, children, effectKey }: EffectProps): JSX.Element {
  const alreadyActivated = effectKey ? isEffectActivated(effectKey) : false;
  const [active, setActive] = useState(alreadyActivated);

  const intensity = (params.intensity as number) ?? 0.5;
  const colorShift = (params.colorShift as boolean) ?? true;

  // 一度発動したらノードが切り替わるまで永続（active=trueのまま）
  useEffect(() => {
    if (alreadyActivated) return;
    const delay = trigger === 'after_delay' ? triggerDelayMs : 0;
    const startTimer = setTimeout(() => {
      setActive(true);
      if (effectKey) markEffectActivated(effectKey);
      onComplete?.();
    }, delay);
    return () => clearTimeout(startTimer);
  }, [trigger, triggerDelayMs, onComplete, alreadyActivated, effectKey]);

  const glitchClass = active
    ? `sn-glitch sn-glitch--intensity-${Math.round(intensity * 10)} ${colorShift ? 'sn-glitch--color' : ''}`
    : '';

  return (
    <div className={glitchClass}>
      {children}
    </div>
  );
}
